export default {"src":"/_next/static/media/roadwise-warranty-logo-light-en.8619da08.svg","height":46,"width":109,"blurWidth":0,"blurHeight":0};